export default __webpack_public_path__ + "static/media/Andrii.c1b2f9bd.png";